import { ComponentConfiguration } from '~/configuration/ComponentConfiguration';
import { type ComponentTag, componentTags } from '~/constants/component-tags';

export class BettingInsightsComponent extends ComponentConfiguration {
	get tag(): ComponentTag {
		return componentTags.OC_PLUS_TOOLS;
	}
}
